import DialogBase from "../libs/DialogBase";
import Util from "../libs/Util";

export default class DialogReviews extends DialogBase {
  constructor() {
    super("#dialog_reviews");

    this.API = LtikeCommon.API.HOTEL.REVIEW;
    const urlParams = new URLSearchParams(window.location.search);

    this.CL_HIDE = "isHide";
    this.CL_SHOW = "isShow";

    this.HOTEL_ID = document.querySelector('[data-hotelid]').dataset.hotelid;
    this.urlParamsReset();

    this.reviewInsertTarget = this.target.querySelector('.-js-reviews')

    document.querySelectorAll('.js-dialog_reviews').forEach(el=>{
      el.addEventListener('click',(e)=>{
        this.onOpen();
      });
    });

    const sentinel = document.createElement('div');
    sentinel.style.height = '1px';
    sentinel.classList.add('-js_sentinel');
    this.reviewInsertTarget.after(sentinel);

    const sentinelObserver = new IntersectionObserver(entries => {
        if (entries[0].isIntersecting) {
          this.nextPage();
        }
      },
      {
        root: null,
        threshold: 0,
        rootMargin: '0px 0px 0px 0px'
      }
    );
    sentinelObserver.observe(sentinel);

    this.loader = this.target.querySelector('.-loader');
    this.loaderCenter = this.target.querySelector('.-loaderCenter');

    this.reCallTimerId = null;
    this.reCallInterval = 300;
    this.controller = null;

    this.isApiCall = false;

    this.isFirstCall = true;
    this.isNextPage = false;
    this.isScrolled = false;

    this.reviewSec = document.querySelectorAll('.js-review_section');
    this.errorSec = document.querySelectorAll('.js-review_error');
    this.errorDialogSec = document.querySelectorAll('.js-review_error_dialog');
    document.querySelectorAll('.js-review_error .-btn_retry button, .js-review_error_dialog .-btn_retry button').forEach(el=>{
      el.addEventListener('click',()=>{
        this.apiCall();
      });
    });

    this.apiCall();
  }

  urlParamsReset(){
    this.pagenumber = 1;
    this.sort = 1;
    this.refinegroup = [];
    this.refinescore = [];
  }

  onChangeFilterItem(){
    clearTimeout(this.reCallTimerId);
    this.reCallTimerId = setTimeout(()=>{
      this.pagenumber = 1;
      this.sort = this.target.querySelector('input[name="sort"]:checked').value;

      this.refinegroup = [];
      this.target.querySelectorAll('input[name="refinegroup"]:checked').forEach(el=>{
        this.refinegroup.push(el.value);
      });
      this.refinescore = [];
      this.target.querySelectorAll('input[name="refinescore"]:checked').forEach(el=>{
        this.refinescore.push(el.value);
      });

      this.apiCall();
    },this.reCallInterval);
  }

  nextPage(){
    if(!this.isNextPage || this.isApiCall) return;
    this.pagenumber++;
    this.isScrolled = true;
    this.apiCall();
  }

  async apiCall(){
    this.isApiCall = true;
    if (this.isScrolled) {
      // スクロールの次ページ呼び出しの場合、スクロールを隠さない
      this.lockDialog();
      this.loader.classList.add(this.CL_SHOW);
    } else {
      // スクロールを隠す
      this.lockDialog(this.target.querySelector('.gl_common_dialog__body'));
      this.loaderCenter.classList.add(this.CL_SHOW);
    }

    const params = new URLSearchParams();
    params.set("hotelid", this.HOTEL_ID);
    params.set("pagenumber",this.pagenumber);
    params.set("sort",this.sort);
    if(this.refinegroup.length > 0) params.set("refinegroup",this.refinegroup.join(','));
    if(this.refinescore.length > 0) params.set("refinescore",this.refinescore.join(','));

    let currentController;

    try {
      if (this.controller) this.controller.abort(); // 古いリクエストを中止

      currentController = new AbortController();
      this.controller = currentController;
      const res = await fetch(`${this.API}?${params.toString()}`,{ signal: this.controller.signal });

      if (this.controller !== currentController) return; // 古いリクエスト排除

      const json = await res.json();
      if(json.getreview4async.result === "OK"){
        this.apiComplete(json);
      } else {
        console.warn('⚠️'+json.getreview4async.errorcode);
        this.apiError();
      }
    } catch (e){
      // Abort以外のエラーはログに出す
      if (e.name !== 'AbortError') {
        console.error(e);
        this.apiError();
      }
    } finally {
      // API呼び出し完了後にロック解除
      // ただし、同時に新しいAPI呼び出しが開始されている可能性があるため、コントローラーを確認してから解除
      if (this.controller === currentController) {
        this.loader.classList.remove(this.CL_SHOW);
        this.loaderCenter.classList.remove(this.CL_SHOW);
        this.isScrolled = false;
        this.unlockDialog();
        this.isApiCall = false;
      }
    }
  }

  apiError(){
    // エラー時は次ページ読み込みを抑制
    this.isNextPage = false;

    if(this.isFirstCall){

      this.target.querySelector('.-js_filter_rate').innerHTML = "";

      this.reviewSec.forEach(el=>el.style.display = 'none');
      this.errorSec.forEach(el=>el.style.display = 'block');
    } else {
      this.reviewInsertTarget.style.display = 'none';
      this.errorDialogSec.forEach(el=>el.style.display = 'block');
    }
  }

  apiComplete(json){
    this.isNextPage = json.getreview4async.nextpage === "true";

    if(json.getreview4async.reviewlist.length === 0){
      // 口コミが0件の場合、0件表示
      if (this.isFirstCall){
        this.reviewSec.forEach(el=>el.style.display = 'none');
        document.querySelectorAll('.js-review_zero').forEach(el=>el.style.display = 'block');
        return;
      } else {
        document.querySelectorAll('.js-review_filter_zero').forEach(el=>el.style.display = 'block');
      }
    } else {
      document.querySelectorAll('.js-review_filter_zero').forEach(el=>el.style.display = 'none');
    }

    const reviewlist = Util.checkItems(json.getreview4async.reviewlist.review);

    if(this.isFirstCall){
      //総合スコア書き換え
      const reviewaverage = json.getreview4async.reviewaverage;
      document.querySelectorAll('.js-review_score').forEach(el=>{
        el.querySelector('.-n').innerHTML = this.scoreToFixed(reviewaverage.rating_average);
        el.querySelector('.-txt').innerHTML = reviewaverage.rating_average_title;
      });

      //件数
      document.querySelector(".js-review_total_count").innerText = json.getreview4async.total;

      //絞り込みメニュー書き込み
      //宿泊タイプ
      const reviewgrouplist = Util.checkItems(json.getreview4async.reviewgrouplist.reviewgroupitem);
      let reviewgroupHtml = '';
      reviewgrouplist.forEach(item=>{
        const txt = `${item.review_group_name}（${item.total}）`;
        reviewgroupHtml += this.createFilterCheckboxHtml('refinegroup',txt,item.review_group_name);
      });
      this.target.querySelector('.-js_filter_group').innerHTML = reviewgroupHtml;
      //口コミスコア
      const reviewratelist = Util.checkItems(json.getreview4async.reviewratelist.reviewrateitem);
      let reviewrateHtml = '';
      reviewratelist.forEach(item=>{
        const rate = item.review_rate;

        const labels = {
          9: '9以上『最高!』',
          8: '8～9『素晴らしい』',
          7: '7～8『とても良い』',
          6: '6～7『良い』',
          5: '6未満『少しがっかり』'
        };
        const label = labels[rate] ?? '';

        const txt = `${label}（${item.total}）`;
        reviewrateHtml += this.createFilterCheckboxHtml('refinescore',txt,rate);
      });
      this.target.querySelector('.-js_filter_rate').innerHTML = reviewrateHtml;

      //filterアイテムにchangeイベント追加
      this.target.querySelectorAll('input[name="sort"],input[name="refinegroup"],input[name="refinescore"]').forEach(el=>{
        el.addEventListener('change',this.onChangeFilterItem.bind(this));
      });

      //概要部分5件書き出し
      let overviewHtml = ``;
      const firstFive = reviewlist.slice(0, 5);
      firstFive.forEach(item=>{
        overviewHtml += `<li><span>${item.review_comments}</span></li>`;
      });
      document.querySelector('.js-review_overview').innerHTML = overviewHtml;

      const firstThree = reviewlist.slice(0, 3);
      let reviewFirstHtml = '';
      firstThree.forEach(item=>{
        reviewFirstHtml += this.createReviewItemHtml(item);
      });
      document.querySelector('.js-review_first').innerHTML = reviewFirstHtml;

      this.isFirstCall = false;
    }

    this.reviewSec.forEach(el=>el.style.display = '');
    this.errorSec.forEach(el=>el.style.display = '');
    this.reviewInsertTarget.style.display = '';
    this.errorDialogSec.forEach(el=>el.style.display = '');

    let reviewlistHtml = '';
    reviewlist.forEach(item=>{
      reviewlistHtml += this.createReviewItemHtml(item);
    });

    if(this.pagenumber === 1){
      //最初の読み込みは上書き
      this.reviewInsertTarget.innerHTML = reviewlistHtml;
    } else {
      //追加読み込み
      this.reviewInsertTarget.insertAdjacentHTML('beforeend', reviewlistHtml);
    }
  }

  createFilterCheckboxHtml(_name,_txt,_value){
    return `<label>
            <input type="checkbox" value="${_value}" name="${_name}" />
            <span class="-box">
                <span class="-icon"></span>
                <span class="-txt"><span aria-hidden="true">${_txt}</span><span>${_txt}</span></span>
            </span>
        </label>`;
  }

  createReviewItemHtml(_data){
    const date = new Date(_data.review_date);
    const dateStr = date.getFullYear() + "年" + (date.getMonth() + 1) + "月" + date.getDate() + "日";

    const point = this.scoreToFixed(_data.rating_average);

    return `<div class="-item">
        <div class="-header">
            <span class="-point">${point}</span>
            <span class="-label">${_data.rating_average_title}</span>
        </div>
        <div class="-comment">${Util.stripHtml(_data.review_comments)}</div>
        <div class="-footer">
            <div class="-type">${_data.rev_hotels_group_name}</div>
            <div class="-date">投稿日：${dateStr}</div>
        </div>
    </div>`;
  }

  scoreToFixed(_str){
    const num = Number(_str);
    if(num < 10){
      return num.toFixed(1);
    } else {
      return _str;
    }
  }


}
